import { render, staticRenderFns } from "./PercentChart.vue?vue&type=template&id=70a6ceec&scoped=true&"
import script from "./PercentChart.vue?vue&type=script&lang=js&"
export * from "./PercentChart.vue?vue&type=script&lang=js&"
import style0 from "./PercentChart.vue?vue&type=style&index=0&id=70a6ceec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a6ceec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
